var _g, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatDoubleColors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M398.223 853.333h455.111l170.667 170.667v-625.777c0-62.834-50.944-113.778-113.778-113.778h-512c-62.834 0-113.778 50.944-113.778 113.778v341.333c0 62.834 50.944 113.778 113.778 113.778z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#20a6d2",
    d: "M654.223 568.889h-483.556l-170.667 170.667v-625.777c0-62.834 50.944-113.778 113.778-113.778h540.444c62.834 0 113.778 50.944 113.778 113.778v341.333c0 62.834-50.944 113.778-113.778 113.778z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatDoubleColors);
export default __webpack_public_path__ + "static/media/chat-double-colors.f15ceb9f00ed1fff5e86c0aed617ddbe.svg";
export { ForwardRef as ReactComponent };